import React, { useEffect } from 'react';
import axios from 'axios';

const RedirectLogin = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const data = {
      username: params.get('username') || '',
      password: atob(params.get('password') || ''), // base64 decode
      account_type: params.get('account_type') || '',
      regi_id: params.get('regi_id') || '',
      academic_year: params.get('academic_year') || '',
    };

    const errors = [];
    if (!data.username) errors.push('Please enter a username');
    if (!data.password) errors.push('Please enter a password.');
    if (!data.account_type) errors.push('Please select an account type.');
    if (!data.academic_year) errors.push('Please select an academic year.');

    if (errors.length > 0) {
      alert(errors.join('\n'));
      return;
    }

    const loginData = {
      username: data.username,
      password: data.password,
      academic_year: data.academic_year,
      regi_id: data.regi_id,
      loginas: data.account_type === 'Parent' ? 'Student' : data.account_type,
    };

    // Submit using axios
    axios.post('/api/auth/login', loginData)
      .then((response) => {
        // Handle successful login
        console.log('Login success:', response.data);
        //window.location.href = '/dashboard'; // Redirect after login
        //window.location = loginData.loginas === 'Student' ? '/student/dashboard' : '/teacher/dashboard';
        window.location = loginData.loginas === 'Student' ? '/student/dashboard' : '/admin/dashboard';
      })
      .catch((error) => {
        // Handle login error
        console.error('Login failed:', error.response?.data || error.message);
        alert('Login failed. Please check credentials.');
      });
  }, []);

  return <div>Redirecting to login...</div>;
};

export default RedirectLogin;